import React, { useEffect } from "react";
import { Modal, Form, Input, Col, Row, message } from "antd";
import { API_METHODS } from "../../../constants";
import useApi from "../../../hooks/useApi";

function AddVideoLinks(props) {
  const [messageApi, contextHolder] = message.useMessage();

  const [form] = Form.useForm();
  const { visible, close, selectedRecord } = props;
  const [response, request] = useApi("/admin/video", null, API_METHODS.POST);
  const [editResponse, editRequest] = useApi(
    `/admin/video/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT
  );

  useEffect(() => {
    if (response.data) {
      close(true);
      messageApi.open({
        type: "success",
        content: "Video Link added successfully.",
      });
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      close(true);
      messageApi.open({
        type: "success",
        content: "Video Link updated successfully.",
      });
    }
  }, [editResponse]);

  useEffect(() => {
    if (selectedRecord) {
      form.setFieldsValue(selectedRecord);
    }
  }, [selectedRecord]);

  const handleCancel = () => {
    close();
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        if (selectedRecord) {
          editRequest(values);
        } else {
          request(values);
        }
      })
      .catch((e) => {});
  };

  return (
    <Modal
      title={selectedRecord ? "Update Video Link" : "Add Video Link"}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      okText="Save"
    >
      {contextHolder}
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="title"
              label="Video Title"
              rules={[{ required: true, message: "Title is required." }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="link"
              label="Video Link"
              rules={[{ required: true, message: "Video Link is required." }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default AddVideoLinks;
